import { Mrf } from "../models/mrf.model";
import { MrfPhoto } from "../models/mrf-photo.model";
import { UuidAndId } from "../models/uuid-and-id";
import { MrfStateModel } from "../state/mrf.state";

export namespace MrfActions {
    export class Refresh {
        static readonly type = '[API-MRF] Refresh'
        constructor() {}
    }
    export class IncrementPendingCount {
        static readonly type = '[Network Service-MRF] Increment Pending Count'
        constructor() {}
    }
    export class Init {
        static readonly type = '[API-MRF] Init'
        constructor(public payload: MrfStateModel) {}
    }
    export class Set {
        static readonly type = '[API-MRF] Set'
        constructor(public payload: Mrf[]) {}
    }
    export class Merge {
        static readonly type = '[API-MRF] Merge'
        constructor(public payload: Mrf[]) {}
    }
    export class AddOne {
        static readonly type = '[UI-MRF] Add One'
        constructor(public payload: Mrf) {}
    }
    export class UpdateOne {
        static readonly type = '[UI-MRF] Update One'
        constructor(public payload: Mrf) {}
    }
    export class DeleteOne {
        static readonly type = '[UI-MRF] Delete One'
        constructor(public payload: Mrf) {}
    }
    export class ApiDeletedOne {
        static readonly type = '[API-MRF] Deleted One'
        constructor(public payload: UuidAndId) {}
    }
    // The server's copy after a POST or PUT of the local MRF uuid, sent when
    // the MRF was at local_rev.
    export class ApiSavedOne {
        static readonly type = '[API-MRF] Saved One'
        constructor(public payload: { uuid: string, local_rev: number | undefined, server: Mrf }) {}
    }
    export class ApiPhotoUploaded {
        static readonly type = '[API-MRF] Photo Uploaded'
        constructor(public payload: { mrf_uuid: string, photo: MrfPhoto }) {}
    }
    // mrf/photos refused it (the line is gone or the MRF is completed).
    export class ApiPhotoDropped {
        static readonly type = '[API-MRF] Photo Dropped'
        constructor(public payload: { mrf_uuid: string, photo_uuid: string }) {}
    }
    export class ApiPhotoDeleted {
        static readonly type = '[API-MRF] Photo Deleted'
        constructor(public payload: { mrf_uuid: string, photo_uuid: string }) {}
    }
    // Everything for this MRF is on the server; clears is_pending_save unless
    // it was saved again since local_rev.
    export class ApiSyncedOne {
        static readonly type = '[API-MRF] Synced One'
        constructor(public payload: { uuid: string, local_rev: number | undefined }) {}
    }
}
